/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "../components/CoverLayout";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "context/authcontext/AuthContext";
import { useContext } from "react";
import { baseUrl } from "utils/api";
import LoaderComponent from "components/Loader";
import SnackBarComponent from "components/AlerComponent";
import { SnackbarContent } from "@mui/material";
import httpClientReq from "services/httpClient";

function Basic() {
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);
  const { dispatch, user } = useContext(AuthContext);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const [openSnack, setOpenSnack] = useState(false);

  const [message, setMessage] = useState("");

  const handleCloseSnack = () => {
    setOpenSnack(false);
  };

  const [formLoading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    email: "",
    password: "",
  });

  const handleChnage = (e) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const handleSumit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await httpClientReq.post(`/login`, {
        ...formState,
      });
      console.log(res.data);
      if (res.status === 200) {
        setLoading(false);
        dispatch({
          type: "USER_LOGIN_SUCCESS",
          payload: res.data?.admin,
        });
        navigate("/");
      }
    } catch (error) {
      setLoading(false);
      setOpenSnack(true);
      setMessage(error.response.data.msg);
    }
  };

  return (
    <CoverLayout>
      {openSnack && (
        <SnackBarComponent
          open={openSnack}
          handleClose={handleCloseSnack}
          message={message}
          type="Error"
        />
      )}
      {formLoading && <LoaderComponent open={true} />}
      <form onSubmit={handleSumit} className="bg-grey-lighter mt-10 flex flex-col">
        <div className="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
          <div className="bg-white px-6 py-8 rounded shadow-md text-black w-full">
            <h1 className="mb-8 text-3xl text-center">Sign In</h1>

            <input
              required
              type="email"
              className="block border border-grey-light w-full p-3 rounded mb-4"
              name="email"
              value={formState.email}
              onChange={handleChnage}
              placeholder="Email"
            />

            <input
              required
              type="password"
              className="block border border-grey-light w-full p-3 rounded mb-4"
              name="password"
              value={formState.password}
              onChange={handleChnage}
              placeholder="Password"
            />

            <button
              type="submit"
              className="w-full cursor-pointer outline-none border-none text-center py-3 rounded bg-blue-400 text-white hover:bg-green-dark focus:outline-none my-1"
            >
              Signin
            </button>
          </div>

          <div className="text-grey-dark mt-6">
            Do not have an account?
            <span
              onClick={() => navigate("/signup")}
              className="no-underline text-blue-400 ml-2 cursor-pointer border-b border-blue text-blue"
              href="../login/"
            >
              Signup
            </span>
            .
          </div>
        </div>
      </form>
    </CoverLayout>
  );
}

export default Basic;
